// config
import api from 'api';

const acceptQuote = async ({ ticketId, quoteId }) => {
  return api.post(
    `price-negotiation/tickets/${ticketId}/quotes/${quoteId}/acceptances/`
  );
};

export default acceptQuote;
